import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'Secure Teleworking Audit',
    title: 'Audit de sécurité',
    description: 'Évaluation complète de votre infrastructure de télétravail actuelle.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Analyse des accès distants." },
      { text: 'Identification des vulnérabilités.' },
      { text: 'Évaluation des outils collaboratifs.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Secure Access Icon',
    title: 'Mise en place des accès sécurisés',
    description: 'Configuration de solutions VPN et d\'authentification multi-facteurs.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Déploiement VPN professionnel.' },
      { text: 'Authentification multi-facteurs (MFA).' },
      { text: 'Gestion centralisée des accès.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Data Protection Icon',
    title: 'Protection des données',
    description: 'Sécurisation des échanges et stockage chiffré des informations sensibles.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Chiffrement end-to-end." },
      { text: 'Sauvegarde automatique sécurisée.' },
      { text: 'Protection contre les fuites de données.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'Monitoring Icon',
    title: 'Surveillance et monitoring',
    description: 'Supervision en temps réel des connexions et détection des anomalies.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Monitoring 24/7 des accès.' },
      { text: 'Détection proactive des menaces.' },
      { text: 'Alertes en temps réel.' },
    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'Formation et sensibilisation',
    description: 'Accompagnement de vos équipes aux bonnes pratiques de télétravail sécurisé.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Formation aux risques cyber.' },
      { text: 'Guide des bonnes pratiques.' },
      { text: 'Support technique dédié.' },
    ],
  },
];
